export default __webpack_public_path__ + "static/slide-5-534d139ff73240472e5acf62efd510c1.jpg";